export default __webpack_public_path__ + "static/AntIcon163-bd46aebedf768bad725350f042512645.png";